module.exports = "https://web-assets-production.autolist.com/_next/static/images/sedan-angled-d3a5764c3380cdb79ebb5652c204b5ff.jpg";